import 'url-search-params-polyfill';

import React, { Component } from 'react';
import { w3cwebsocket as W3CWebSocket } from 'websocket';

import { Helmet } from 'react-helmet';
import * as jwtDecode from 'jwt-decode';
import IdleTimer from 'react-idle-timer';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';


// Local Deps
import AuthRoute from './components/Auth/AuthRoute';
import { logout } from './utils/authUtils';
// import { logoutServices } from './graphql/serviceAuthentication';
import './scss/index.scss';
import history from './config/history';
import { getOrgByID, getMessageCount } from './graphql';
// import { UserForApproveUser } from './graphql/users';

// Navigation
import {
  homeRoute,
  aboutRoute,
  contactRoute,
  iconfaqsRoute,
  helpRoute,
  codeDefinitionsRoute,
  relNotesRoute,
  newslettersRoute,
  loginRoute,
  loginFailureRoute,
  registrationRoute,

  solicitationsSearchRoute,
  solicitationsShowRoute,

  toolingLocationListRoute,
  // toolingLocationRoute,
  // procurementHistoryRoute,
  supplierCapabilitiesRoute,
  universalDetailsRoute,

  messageCenterRoute,
  contractCenterRoute,
  contractRfqRoute,
  contractQuoteRoute,
  viewQuoteRoute,
  DibbsRFQWizardRoute,

  toolingManagementRoute,
  inventoryManagementRoute,

  accountAdminRoute,
  // bidMatchingRoute,
  // addUserRoute,
  // editUserRoute,
  superAdminHomeRoute,
  // superAdminEditOrgRoute,

  pdmiCredentialsRoute,

  // downloadToolingRoute,
  // editInventoryManagementRoute,
  // orgToolingRoute,
  // addProductRoute,
  // editToolingRoute,
  // editToolingManagementRoute,

} from './config/navigation/routes';

// Pages

// Static Pages
import Home from './pages/static/Home';
import About from './pages/static/About';
import Contact from './pages/static/Contact';
import iconfaqs from './pages/static/iconfaqs';
import help from './pages/static/help';
import CodeDefinitions from './pages/static/CodeDefinitions';
import relnotes from './pages/static/relnotes';
import newsletters from './pages/static/newsletters';
import IntermediateLogin from './pages/static/IntermediateLogin';
import Registration from './pages/Registration';


import SolicitationsSearch from './pages/SolicitationsSearch';
import SolicitationDetail from './pages/SolicitationDetail';
import ToolingLocations from './pages/ToolingLocations';
// import ToolingLocations2 from './pages/ProcurementHistory';
import SupplierCapabilities from './pages/SupplierCapabilities';
import UniversalDetails from './pages/universalDetails';

import MessageCenter from './pages/messageCenter';

import ContractCenter from './pages/ContractCenter';
import ContractRFQ from './pages/contractRFQ';
import ContractQuote from './pages/contractQuote';
import ViewQuote from './pages/ViewQuote';
import DibbsRFQWizard from './pages/DibbsRfq';

import ToolingManagement from './pages/ToolingManagement';
import InventoryManagement from './pages/InventoryManagement';

import AccountAdmin from './pages/AccountAdmin';
// import Notifications from './pages/Notifications'; // This is for bidmatching settings

import SuperAdminHome from './pages/SuperAdminHome';
// import EditOrganization from './components/Modals/EditOrganization';

// import AddUser from './pages/AddUser';
// import EditUser from './pages/EditUser';
// import ToolingMgmt from './pages/ToolingMgmt';
// import AddProduct from './pages/AddProduct/AddProduct';

// import DownloadTooling from './pages/DownloadTooling/DownloadTooling';

// import EditInventoryManagement from './pages/EditInventoryManagement';

// import EditProduct from './pages/EditProduct';
// import EditToolingManagement from './components/Modals/EditToolingManagement';
import PdmiCredentials from './pages/PdmiCredentials';

// Components
import TopNav from './components/TopNav';
import IconFooter from './components/IconFooter/IconFooter';
// import ToolingLocationsDetail from './components/ToolingLocationsDetail';
import NFButton from './components/primitives/NFButton';

export default class Root extends Component {
  static initialState = {
    auth: {
      jwtToken: null,
      expiration: 0,
      role: null,
      id: null,
      organizationId: null,
      permissions: null,
      cageCode: null,
    },
    originalOrgId: null,
    orgInfo: null,
    newMessage: false,
    newMessageCount: 0,
    client: null,
    updateConversation: false,
    updateConversationList: false,
    canSeeMessageCenter: false,
    loginFailureAlertMessage: [{
      alertType: 'warning',
      alertMessage: 'There was an error logging in. Support has been notified',
    }],
    forceLogout: false,
    // udHistory: null,
  };

  static _getDecodedAuthData(jwtToken) {
    const decoded = jwtDecode(jwtToken);
    console.log("decoded", decoded)
    const id = decoded[`${process.env.REACT_APP_AUTH0_NAMESPACE}/id`];
    return {
      jwtToken,
      expiration: decoded.exp,
      role: decoded[`${process.env.REACT_APP_AUTH0_NAMESPACE}/role`],
      id,
      organizationId: decoded[`${process.env.REACT_APP_AUTH0_NAMESPACE}/orgId`],
      permissions: decoded[`${process.env.REACT_APP_AUTH0_NAMESPACE}/permissions`],
      name: decoded.name,
      email: decoded.email,
      cageCode: decoded[`${process.env.REACT_APP_AUTH0_NAMESPACE}/cageCode`],
    };
  }

  constructor() {
    super();
    this._isMounted = false;
    this.state = Root.initialState;
    const jwtToken = this._getCookie('idToken');
    if (jwtToken) {
      this.state.auth = Root._getDecodedAuthData(jwtToken);
    }

    if (performance.navigation.type !== 1) {
      if (document.cookie.indexOf('idToken=') !== -1) {
        if (
          !window.location.pathname.includes('/superadmin') &&
          !window.location.pathname.includes('/support/solicitations') &&
          !window.location.pathname.includes('/help') &&
          !window.location.pathname.includes('/support/codedefinitions') &&
          !window.location.pathname.includes('/solicitations') &&
          !window.location.pathname.includes('/tools/locator') &&
          !window.location.pathname.includes('/history/search') &&
          !window.location.pathname.includes('/about') &&
          !window.location.pathname.includes('/contact') &&
          !window.location.pathname.includes('/rfq') &&
          !window.location.pathname.includes('/cfolders') &&
          !window.location.pathname.includes('/login') &&
          !window.location.pathname.includes('/messagecenter') &&
          !window.location.pathname.includes('/details') &&
          !window.location.pathname.includes('/suppliers') &&
          !window.location.pathname.includes('/contractcenter') &&
          !window.location.pathname.includes('/memberadmin/inventorymanagement/') &&
          !window.location.pathname.includes('/memberadmin/toolingmanagement/')
        ) {
          logout();
        }
      }
    }
  }

  async componentDidMount() {
    console.log("componentDidMount")
    this._isMounted = true;
    const jwtToken = this._getCookie('idToken');
    if (jwtToken) {
      console.log("componentDidMount plus jwt")
      const auth = await this._updateStateWithAuth(jwtToken);

      this._getUserOrgInfo(auth);
      this.setupWebsocket(jwtToken, auth)

    }
  }

  componentWillUnmount() {
    // fixes memory leak
    this._isMounted = false;
    if (this.state && this.state.client) {
      this.state.client.close();
    }
  }

  setupWebsocket = (jwtToken, auth) => {
    // if (auth.client) return;
    console.log(process.env.REACT_APP_WEBSOCKET);

    const client = new W3CWebSocket(
      `${process.env.REACT_APP_WEBSOCKET}?jwtToken=${jwtToken}`,
    );
    this.setState({ client });

    client.onopen = () => {
      console.log('WebSocket Client Connected');
    };

    client.onerror = () => {
      console.log('websocket error');
    };

    client.onmessage = async message => {
      console.log("client.onmessage fired");
      console.log("message.data", message.data)
      const data = JSON.parse(message.data);
      console.log(data);
      if (data.forceLogout) {
        console.log("forced logout here")
        this.setState({ forceLogout: true });
        setTimeout(logout, 3000);
      } else {
        const urlParams = new URLSearchParams(window.location.search);
        const myParam = urlParams.get('message');
        // console.log(myParam);
        if (
          window.location.pathname.includes('/messagecenter') &&
          data.convoId === myParam
        ) {
          // console.log("client.onmessage includes /messagecenter &&  convoId === myParam");
          this.setState({ updateConversation: true });
        }
        if (window.location.pathname.includes('/messagecenter') && !myParam) {
          // console.log("client.onmessage includes /messagecenter &&  !myParam");
          this.setState({ updateConversationList: true });
        } else {
          // console.log("client.onmessage else");
          // console.log("getMessageCount1", auth.id)
          const res = await getMessageCount(auth.id);
          this.setState({
            newMessage: true,
            newMessageCount: res.newMsgCount
          });
        }
      }

    };
  }

  _setMessageNotification = async () => {
    // console.log("getMessageCount2", this.state.auth.id)

    const res = await getMessageCount(this.state.auth.id);
    this.setState({
      newMessage: res.newMsgCount > 0,
      newMessageCount: res.newMsgCount
    });
  };

  _getUserOrgInfo = async (auth) => {
    if (auth && auth.id) {
      try {
        const org = await getOrgByID(auth.organizationId);
        this.setState({
          orgInfo: org,
        });
      } catch (err) {
        console.error(err);
      }
    }
    if (auth && auth.permissions && auth.permissions.includes(1)) {
      this.setState({ canSeeMessageCenter: true });
      try {
        const res = await getMessageCount(auth.id);
        if (res.newMsgCount > 0) {
          this.setState({
            newMessage: true,
            newMessageCount: res.newMsgCount
          });
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  _getCookie = cname => {
    const name = `${cname}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  };

  _updateStateWithAuth = async jwtToken => {
    const auth = await Root._getDecodedAuthData(jwtToken);
    this.setState({
      auth,
    }
      // ,
      //   console.log("update", this.state.auth)
    );
    return auth;
  };

  _login = async jwtToken => {
    console.log("_login");
    if (!jwtToken) {
      return;
    }
    const auth = await this._updateStateWithAuth(jwtToken);
    this._getUserOrgInfo(auth);
    this.setupWebsocket(jwtToken, auth)
    history.push('/');
  };

  _onIdle = () => {
    logout();
  };

  _resetUpdateConversation = () => {
    this.setState({ updateConversation: false, updateConversationList: false });
  };

  render() {
    // console.log("orgInfo", this.state.orgInfo)
    const {
      auth,
      originalOrgId,
      orgInfo,
      newMessage,
      newMessageCount,
      updateConversation,
      updateConversationList,
      canSeeMessageCenter,
      loginFailureAlertMessage,
      forceLogout,
    } = this.state;
    return (
      <div id="site-container">
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Home Page</title>
          <meta
            name="description"
            content="The Integrated Casting Order Networks (ICON) provides the DLA and manufacturers with innovative procurement solutions for defense related metal castings."
          />
          <meta
            name="keywords"
            content="machine tooling,casting tooling,foundry pattern,military castings,amc icon,foundry tooling,icon portal"
          />
        </Helmet>

        <Router history={history}>
          <React.Fragment>
            <Switch>
              {/* <!-- HOME PAGE --> */}
              <Route
                exact
                path={homeRoute}
                render={props => (
                  <Home
                    login={this._login}
                    logout={logout}
                    auth={auth}
                    originalOrgId={originalOrgId}
                    orgInfo={orgInfo}
                    newMessage={newMessage}
                    newMessageCount={newMessageCount}
                    canSeeMessageCenter={canSeeMessageCenter}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path={loginFailureRoute}
                render={props => (
                  <Home
                    login={this._login}
                    logout={logout}
                    auth={auth}
                    originalOrgId={originalOrgId}
                    orgInfo={orgInfo}
                    newMessage={newMessage}
                    newMessageCount={newMessageCount}
                    canSeeMessageCenter={canSeeMessageCenter}
                    alertMessages={loginFailureAlertMessage}
                    {...props}
                  />
                )}
              />
              <Route
                render={() => (
                  <div>
                    {/* <!-- TOP NAV BAR --> */}
                    <TopNav
                      login={this._login}
                      logout={logout}
                      auth={auth}
                      originalOrgId={originalOrgId}
                      orgInfo={orgInfo}
                      newMessage={newMessage}
                      newMessageCount={newMessageCount}
                      canSeeMessageCenter={canSeeMessageCenter}
                      className="nf-top-nav--dark"
                    />
                    <div id="content-wrap">
                      <Switch>
                        {/* <!-- STATIC ROUTES --> */}
                        <Route exact path={aboutRoute} component={About} />
                        <Route exact path={contactRoute} component={Contact} />
                        <Route exact path={iconfaqsRoute} component={iconfaqs} />
                        <Route exact path={helpRoute} component={help} />
                        <Route exact path={codeDefinitionsRoute} component={CodeDefinitions} />
                        <Route exact path={relNotesRoute} component={relnotes} />
                        <Route exact path={newslettersRoute} component={newsletters} />

                        {/* <!-- LOGIN PAGE --> */}
                        <Route
                          path={loginRoute}
                          render={() => (
                            <IntermediateLogin
                              login={this._login}
                              auth={auth}
                              history={history}
                            />
                          )}
                        />
                        {/* <!-- REGISTRATION PAGE --> */}
                        <Route
                          exact
                          auth={auth}
                          path={registrationRoute}
                          render={() => <Registration
                            auth={auth}
                          />
                          }
                        />
                        {/* <!-- SOLICITATIONS PAGES --> */}
                        <AuthRoute
                          auth={auth}
                          exact
                          path={solicitationsSearchRoute}
                          render={() => <SolicitationsSearch auth={auth} />}
                        />
                        <AuthRoute
                          auth={auth}
                          exact
                          path={solicitationsShowRoute}
                          render={props => (
                            <SolicitationDetail
                              solicitationId={props.match.params.solicitationId}
                              auth={auth}
                            />
                          )}
                        />
                        {/* <!-- TOOLING LOCATIONS PAGE --> */}
                        <Route
                          exact
                          path={toolingLocationListRoute}
                          render={() => (
                            <ToolingLocations
                              auth={auth}
                            // setUniversalDetailsHistory={this._setUniversalDetailsHistory}
                            />
                          )}
                        />
                        <Route
                          auth={auth}
                          exact
                          path={supplierCapabilitiesRoute}
                          render={props => (
                            <SupplierCapabilities auth={auth} {...props} />
                          )}
                        />

                        {/* <!-- UNIVERSAL DETAILS PAGE --> */}
                        <AuthRoute
                          auth={auth}
                          exact
                          path={universalDetailsRoute}
                          render={() => (
                            <UniversalDetails
                              auth={auth}
                            // udHistory={this.state.udHistory}
                            />
                          )}
                        />

                        {/* <!-- Message Center PAGE --> */}
                        <AuthRoute
                          auth={auth}
                          exact
                          path={messageCenterRoute}
                          roles={['GOVERNMENT_USER', 'COMMON_USER', 'COMMON_ADMIN']}
                          render={() => (
                            <MessageCenter
                              auth={auth}
                              resetUpdateConversation={
                                this._resetUpdateConversation
                              }
                              setMessageNotification={
                                this._setMessageNotification
                              }
                              updateConversation={updateConversation}
                              updateConversationList={updateConversationList}
                            />
                          )}
                        />

                        {/* CONTRACT CENTER PAGES */}
                        <AuthRoute
                          auth={auth}
                          exact
                          path={contractCenterRoute}
                          // roles={['SUPER_ADMIN']}
                          roles={['GOVERNMENT_USER', 'COMMON_USER', 'COMMON_ADMIN']}
                          render={() => <ContractCenter auth={auth} />}
                        />

                        <AuthRoute
                          auth={auth}
                          exact
                          path={contractRfqRoute}
                          roles={['GOVERNMENT_USER', 'COMMON_USER', 'COMMON_ADMIN']}
                          // roles={['COMMON_USER', 'COMMON_ADMIN']}
                          render={() => <ContractRFQ auth={auth} />}
                        />

                        <AuthRoute
                          auth={auth}
                          exact
                          path={viewQuoteRoute}
                          roles={['GOVERNMENT_USER', 'COMMON_USER', 'COMMON_ADMIN']}
                          // roles={['COMMON_USER', 'COMMON_ADMIN']}
                          render={props => <ViewQuote auth={auth} {...props} />}
                        />

                        <AuthRoute
                          auth={auth}
                          exact
                          path={contractQuoteRoute}
                          roles={['GOVERNMENT_USER', 'COMMON_USER', 'COMMON_ADMIN']}
                          // roles={['COMMON_USER', 'COMMON_ADMIN']}
                          render={() => <ContractQuote auth={auth} />}
                        />

                        <AuthRoute
                          auth={auth}
                          exact
                          path={DibbsRFQWizardRoute}
                          roles={['SUPER_ADMIN']}
                          // roles={['COMMON_USER', 'COMMON_ADMIN']}
                          render={props => (
                            <DibbsRFQWizard auth={auth} {...props} />
                          )}
                        />
                        {/* <!-- TOOLING & INVENTORY MANAGEMENT PAGES --> */}
                        <AuthRoute
                          auth={auth}
                          // @TODO define these roles correctly
                          roles={['COMMON_USER', 'COMMON_ADMIN']}
                          exact
                          path={toolingManagementRoute}
                          render={() => <ToolingManagement auth={auth} />}
                        />

                        <AuthRoute
                          auth={auth}
                          // @TODO define these roles correctly
                          roles={['COMMON_USER', 'COMMON_ADMIN']}
                          exact
                          path={inventoryManagementRoute}
                          render={() => <InventoryManagement auth={auth} />}
                        />

                        {/* <!-- ACCOUNT ADMIN PAGES --> */}
                        <AuthRoute
                          auth={auth}
                          // @TODO define these roles correctly
                          roles={['COMMON_ADMIN']}
                          exact
                          path={accountAdminRoute}
                          render={() => <AccountAdmin auth={auth} />}
                        />


                        {/* SUPER ADMIN PAGES */}
                        <AuthRoute
                          auth={auth}
                          roles={['SUPER_ADMIN']}
                          exact
                          path={superAdminHomeRoute}
                          render={() => <SuperAdminHome auth={auth} />}
                        />

                        {/* <!-- PDMI CREDENTIALS PAGE --> */}
                        <AuthRoute
                          auth={auth}
                          exact
                          path={pdmiCredentialsRoute}
                          render={props => <PdmiCredentials {...props} />}
                        />









                        <Redirect to={homeRoute} />
                      </Switch>
                    </div>
                    {auth && (
                      <IdleTimer
                        ref={ref => {
                          this.idleTimer = ref;
                        }}
                        element={document}
                        onActive={this.onActive}
                        onIdle={this._onIdle}
                        onAction={this.onAction}
                        debounce={250}
                        timeout={1000 * 60 * 30}
                      />
                    )}
                  </div>
                )}
              />
            </Switch>
            <Modal
              isOpen={forceLogout}
              toggle={logout}
            >
              <ModalHeader >Your permissions have changed</ModalHeader>
              <ModalBody>
                A site or organiation administrator has changed your permissions. Please logout and login again so the changes can take affect.
              </ModalBody>
              <ModalFooter>
                <NFButton
                  className="nf-button nf-button--form nf-button--orange"
                  onClick={logout}
                >
                  Logout
                </NFButton>
              </ModalFooter>

            </Modal>
            <IconFooter />
          </React.Fragment>
        </Router>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root.jsx